<mat-expansion-panel
  [formGroup]="buttonForm()"
  [expanded]="btnIndex() === 0"
  (closed)="expansionClosed.emit()"
  (opened)="expansionOpened.emit()"
>
  <mat-expansion-panel-header>
    <mat-panel-title
      class="button-title"
      [ngClass]="{
        'button-title--success': buttonForm().valid && buttonData.type !== 'none',
        'button-title--warning': !buttonForm().valid,
      }"
    >
      {{ buttonTitle }}
    </mat-panel-title>
    <mat-panel-description class="button-title">
      {{ buttonLabel }}
    </mat-panel-description>
  </mat-expansion-panel-header>

  <app-mat-simple-select
    label="Type"
    name="buttonType"
    formControlName="type"
    [selectItems]="lookupButtonTypes()"
    [labelExplanation]="buttonTypeDescription"
    [submitted]="formSubmitted()"
    (valueChanged)="onButtonTypeChange($event)"
  >
  </app-mat-simple-select>

  <app-mat-simple-select
    *ngIf="isParameterVisible && buttonData.type !== buttonTypes.Speed"
    [label]="parameterFieldLabel"
    name="buttonParameter"
    formControlName="parameter"
    [selectItems]="parameterValues"
    [searchEnabled]="true"
    [submitted]="formSubmitted()"
    (valueChanged)="onParameterChange()"
  ></app-mat-simple-select>

  <app-mat-text-input
    *ngIf="buttonData.type === buttonTypes.Speed"
    name="dialNumber"
    appPhoneNumberSanitizer
    [formControl]="$any(buttonForm().get('parameter'))"
    [label]="parameterFieldLabel"
    [submitted]="formSubmitted()"
  ></app-mat-text-input>

  <app-mat-text-input
    *ngIf="buttonData.type !== buttonTypes.None"
    label="Label"
    name="buttonLabel"
    formControlName="label"
    explanationIcon="edit"
    explanation="Label can be edited"
    [placeholder]="defaultLabel"
    [submitted]="formSubmitted()"
  ></app-mat-text-input>
</mat-expansion-panel>
